export const environment = {
  production: true,
  apiHost: 'http:///portal-data:8080/data',
  ipApiHost: 'https://www.taiwan.nps.gov.tw/data',
  editApiHost: 'https://www.taiwan.nps.gov.tw/data',
  templateEditApiHost: 'https://www.taiwan.nps.gov.tw/data',
  allowBackStageDomain: ['https://www.taiwan.nps.gov.tw'],
  mode: 'path',
  accessTokenKey: 'backend_auth_token',
  refreshTokenKey: 'backend_auth_refresh_token',
  recaptchaKey: '',
  commonToken: '8CC1C549-35D7-4691-9E1D-67D8EC7951B5',
  frontsideUrl: 'https://www.taiwan.nps.gov.tw',
  baseHref: '/',
  tgosAPIKey: 'mAemqJDNF2pi7iy/jhR/1a1QXHS9iH/7Unzew/WnDqyXiqY4Ob9+MkiBbSKLvr0vdk63sQW1dMbytzw6EGmFHEXwUNqq9947WtZCg0T7/9m67SRkLI6pfp44ehGS8BW5',
};
